import { useEffect, useState } from 'react';

const ErrorBoundary = ({ children }) => {
	const [hasError, setHasError] = useState(false);
	const [error, setError] = useState(null);
	const [errorInfo, setErrorInfo] = useState(null);

	useEffect(() => {
		const handleError = (error, errorInfo) => {
			setHasError(true);
			setError(error);
			setErrorInfo(errorInfo);
		};
		
		window.addEventListener('error', handleError);

		return () => {
			window.removeEventListener('error', handleError);
		};
	}, []);

	if (hasError) {
		return (
			<div>
				<h2>Something went wrong.</h2>
				<p>{error?.message}</p>
				<p>{errorInfo?.componentStack}</p>
			</div>
		);
	}
	return children;
};

export default ErrorBoundary;
